export class Meeting {
  constructor(
    public id: string = "",
    public name: string = "",
    public classroom: string = "",
    public course: string = "",
    public record: boolean = false,
    public isPublic: boolean = false,
    public start_date = "",
    public end_date = "",
  ) { }
}
export class EventForm {
  constructor(
    public id: string = "",
    public name: string = "",
    public classroom: string = "",
    public course: string = "",
    public record: boolean = false,
    public isPublic: boolean = false,
    public startTime: string = "",
    public endTime: string = "",
    public date: string = ""
  ) {}
}